import { render, staticRenderFns } from "./TSublime.vue?vue&type=template&id=354123b8&scoped=true&"
import script from "./TSublime.vue?vue&type=script&lang=js&"
export * from "./TSublime.vue?vue&type=script&lang=js&"
import style0 from "./TSublime.vue?vue&type=style&index=0&id=354123b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354123b8",
  null
  
)

export default component.exports